/**
 * Format a 24-hour "HH:mm" or "HH:mm:ss" string (as stored/sent by the API)
 * into a 12-hour clock string with AM/PM, e.g. "14:30" -> "2:30 PM".
 * Used across the app since Latin America displays clock times in 12h format.
 */
export function formatTime(time: string | null | undefined): string {
  if (!time) return '';
  const [h, m] = time.split(':');
  const hour = parseInt(h, 10);
  if (Number.isNaN(hour)) return '';
  const minute = (m ?? '00').padStart(2, '0');
  const ampm = hour >= 12 ? 'PM' : 'AM';
  const displayHour = hour % 12 || 12;
  return `${displayHour}:${minute} ${ampm}`;
}
